import { resolveEnvironment } from '~shared/consts'

export const ENVIRONMENT = resolveEnvironment({
  projectId: import.meta.env.VITE_PROJECT_ID,
  isLocal: import.meta.env.DEV,
})
